import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/EnpointCards.css';
import labService from './labService';
import authService from '../auth/authService';
import HashLoader from "react-spinners/HashLoader";

const EndpointCards = () => {
  const [endpoints, setEndpoints] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [endpsLoading, setEndpsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const user = authService.getCurrentUser();
    setCurrentUser(user);
  }, []);

  useEffect(() => {
    if (currentUser) {
      labService.getEndpoints(currentUser.access)
        .then(response => {
          setEndpoints(response.data)
          setEndpsLoading(false)
        })
        .catch(error => console.error(error));
    }
  }, [currentUser]);

  const handleNewPredictionClick = (endpoint, hasModels) => {
    if (hasModels) {
    localStorage.setItem('selectedEndpoint', JSON.stringify(endpoint.id));
    navigate(`/choose-model/${endpoint.id}`);
    }
  };

  return (
    <div className="home-content">
      <h2 className='aval-endp'>Available endpoints</h2>
      {endpsLoading ? (
        <div className='loader-div'>
          <HashLoader className='loader' size={120} color='#0b5578' />
        </div>
      ) : (
        <div className='cards-container'>
          {endpoints.map((endpoint) => {
            const hasModels = endpoint.ml_models && endpoint.ml_models.length > 0;
            const imgUrl = hasModels ? endpoint.img_url : endpoint.img_non_act_url;
            const cardClass = hasModels ? 'card active' : 'card non-active-card';
            return (
              <div className='card-wrapper' key={endpoint.id}>
                <div className={cardClass} onClick={() => handleNewPredictionClick(endpoint, hasModels)}>
                  {!hasModels && <div className="coming-soon-banner">AVAILABLE SOON!</div>}
                  <h2>{endpoint.endpoint_name}</h2>
                  <img src={imgUrl} alt={endpoint.endpoint_name} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default EndpointCards;
